import React from "react";
import School from "../Experience/Company";
import { Col, Container, Row } from "react-bootstrap";

const Education = (props) => {
  const { institution, area, studyType, startDate, endDate, gpa } = props;
  return (
    <>
      {" "}
      <h2 className="heading">Education</h2>
      <Container>
        <Row>
          <Col sm={4}>
            <div
              style={{ fontWeight: "100" }}
            >{`${startDate} - ${endDate}`}</div>
            <div style={{ fontWeight: "300", fontSize: "1.5rem" }}>
              {institution}
            </div>
            <div style={{ fontWeight: "300" }}>{area}</div>
          </Col>
          <Col sm={8}>
            <div>{studyType}</div>
          </Col>
        </Row>
      </Container>
      {/* <School company="Tel Aviv University" summary="bla bla bla" /> */}
    </>
  );
};

export default Education;
